import React, { useState, useMemo } from "react";
import { Layout, Typography, Card, Row, Col, Button, Input, Pagination } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const profiles = [
  {
    id: 1,
    name: "Dr. Jane Smith",
    title: "AI Researcher & Innovator",
    description: "Dr. Smith has pioneered advancements in natural language processing and AI ethics.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d877993ecb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 2,
    name: "John Doe",
    title: "Cybersecurity Expert",
    description: "John has developed state-of-the-art security frameworks to protect digital ecosystems.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 3,
    name: "Emily Zhang",
    title: "Data Science Mentor",
    description: "Emily has guided thousands of students in mastering data science and AI-driven analytics.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 4,
    name: "Michael Lee",
    title: "Tech Entrepreneur",
    description: "Michael founded an AI-driven startup that transforms industries with automation and efficiency.",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 5,
    name: "Aisha Nkosi",
    title: "AI Ethics Advocate",
    description: "Aisha works to ensure AI systems are fair and inclusive, influencing global policies.",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 6,
    name: "Liam Okoye",
    title: "Cybersecurity Innovator",
    description: "Liam’s cutting-edge solutions have fortified defenses against emerging cyber threats.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 7,
    name: "Sophie Kim",
    title: "Data Science Leader",
    description: "Sophie leads groundbreaking projects in big data analytics for global corporations.",
    image: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 8,
    name: "Tariq Hassan",
    title: "AI Startup Founder",
    description: "Tariq’s startup leverages AI to revolutionize healthcare delivery in underserved regions.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 9,
    name: "Nia Patel",
    title: "Cybersecurity Educator",
    description: "Nia trains the next generation of cybersecurity experts with practical, hands-on methods.",
    image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80",
  },
];

const ProfilesInBrilliance = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  const filteredProfiles = useMemo(() => {
    const query = searchQuery.toLowerCase();
    return profiles.filter(
      (profile) =>
        profile.name.toLowerCase().includes(query) ||
        profile.description.toLowerCase().includes(query)
    );
  }, [searchQuery]);

  const paginatedProfiles = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredProfiles.slice(startIndex, startIndex + pageSize);
  }, [filteredProfiles, currentPage]);

  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff" }}>
          Profiles in Brilliance
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", marginBottom: "24px" }}>
          Meet the brilliant minds who are making significant contributions to the fields of AI, Cybersecurity, and Data Science.
        </Paragraph>

        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          <Col xs={24} md={12}>
            <Input
              placeholder="Search profiles by name or description"
              prefix={<SearchOutlined />}
              size="large"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ borderRadius: "4px" }}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          {paginatedProfiles.length > 0 ? (
            paginatedProfiles.map((profile) => (
              <Col xs={24} sm={12} md={8} lg={6} key={profile.id}>
                <Card
                  hoverable
                  cover={
                    <img
                      alt={profile.name}
                      src={profile.image}
                      style={{ height: "150px", objectFit: "cover", borderRadius: "8px 8px 0 0" }}
                    />
                  }
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  bodyStyle={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}
                >
                  <div>
                    <Title level={4} style={{ marginBottom: "8px", color: "#333" }}>
                      {profile.name}
                    </Title>
                    <Paragraph style={{ color: "#666", fontSize: "14px", marginBottom: "12px" }}>
                      <strong>{profile.title}</strong>
                    </Paragraph>
                    <Paragraph style={{ color: "#666", fontSize: "14px" }}>
                      {profile.description}
                    </Paragraph>
                  </div>
                  <Button
                    type="primary"
                    href="/signin"
                    style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", width: "100%", marginTop: "16px" }}
                  >
                    Learn More
                  </Button>
                </Card>
              </Col>
            ))
          ) : (
            <Col span={24} style={{ textAlign: "center" }}>
              <Paragraph style={{ color: "#999", fontSize: "16px" }}>
                No profiles match your search. Try a different query!
              </Paragraph>
            </Col>
          )}
        </Row>

        <Pagination
          current={currentPage}
          total={filteredProfiles.length}
          pageSize={pageSize}
          onChange={setCurrentPage}
          style={{ marginTop: "24px", textAlign: "center" }}
          showSizeChanger={false}
        />
      </Content>
    </Layout>
  );
};

export default ProfilesInBrilliance;